import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ConfigProvider } from "antd";
import zhCN from "antd/es/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
import "./index.css";
import App from "./App";
import { Provider } from "mobx-react";
import stores from "@/stores";
import reportWebVitals from "./reportWebVitals";

moment.locale("zh-cn");
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}
// fetchToken(); // 验证token
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider {...stores}>
    {/* <React.StrictMode> */}
      <BrowserRouter>
        <ConfigProvider locale={zhCN}>
          <App />
        </ConfigProvider>
      </BrowserRouter>
    {/* </React.StrictMode> */}
  </Provider>
);



// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
